export default __webpack_public_path__ + "static/media/Ohio_Figma.05d420cc.jpg";